import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

// Import Public Page Components
import HomePage from './pages/HomePage.js';
import LoginPage from './pages/LoginPage.js';
import MenuPage from './pages/MenuPage.js';

// Import Preloader
import Preloader from './components/Preloader.js';

// Import Protected Page Components
import UserDashboard from './pages/UserDashboard.js';
import AdminDashboard from './pages/AdminDashboard.js';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute.js';

function App() {
  const [loading, setLoading] = useState(true);

  // This effect checks if the preloader has run before in this session.
  useEffect(() => {
    // To see the animation every time you refresh, comment out this if-statement.
    if (sessionStorage.getItem('hasLoaded')) {
      setLoading(false);
    }
  }, []);

  // This function is called by the Preloader component when its animation finishes.
  const handleAnimationComplete = () => {
    setLoading(false);
    // We set an item in the browser's session storage so the preloader doesn't run again
    // if the user navigates to another page and comes back.
    sessionStorage.setItem('hasLoaded', 'true');
  };

  return (
    <>
      {/* Show the preloader only if loading is true */}
      {loading && <Preloader onAnimationComplete={handleAnimationComplete} />}
      
      {/* This div wraps your main content, making it fade in smoothly after loading */}
      <div className={`app-content ${loading ? 'loading' : 'loaded'}`}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/menu" element={<MenuPage />} />

          {/* Protected User Route */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <UserDashboard />
              </ProtectedRoute>
            } 
          />

          {/* Protected Admin Route */}
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } 
          />
        </Routes>
      </div>
    </>
  );
}

export default App;

